// If you are caching any values in memory, make sure to add the ability to clear that data here. 
// This will ensure that the user sees the most up-to-date information.
// This is especially important for user specific data that may be cached in memory.

// import useDocType from "../hooks/useDocType";
import { ClearTSCache } from "./TanStackQuery";

export const ClearAllCaches = () => { 
    ClearTSCache()
    // useDocType(true)
//    localStorage.clear()
    // ** TODO: Add our other caches to clear here
}
